import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public loading: boolean;
  constructor(
    private loaderService: LoaderService,
    private changeDetector: ChangeDetectorRef  
  ) {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
      if (v) {
        document.body.style.overflow = "hidden";
      }else{
        document.body.style.overflowY = "auto";
      }
    });
  } 

  ngOnInit(): void {
  }

  ngAfterContentChecked(): void{
    this.changeDetector.detectChanges();
  }

}
